import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const SparkleFilled = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        ref={forwardedRef}
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.5 1L4.17523 2.82477L6 3.5L4.17523 4.17523L3.5 6L2.82477 4.17523L1 3.5L2.82477 2.82477L3.5 1Z"
          fill={color}
        />
        <path
          d="M10 2.5L11.4855 6.5145L15.5 8L11.4855 9.4855L10 13.5L8.5145 9.4855L4.5 8L8.5145 6.5145L10 2.5Z"
          fill={color}
        />
        <path
          d="M4.25 10.5L4.8577 12.1423L6.5 12.75L4.8577 13.3577L4.25 15L3.6423 13.3577L2 12.75L3.6423 12.1423L4.25 10.5Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default SparkleFilled
